import { NgFor, NgIf, UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-footer-rapallo',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './footer.component.html',
  styleUrl:'../../../../../../assets/styles/bootstrap-italia-comuni.min.css',
  encapsulation  : ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RapalloFooterComponent implements OnInit {

    htmlContent='';

	constructor(
      private activatedRoute: ActivatedRoute,
      private sanitizer: DomSanitizer,
	) {}


	ngOnInit() {

      this.activatedRoute.data.subscribe(({isweb}) => {

        if (isweb && isweb.length>0){
            const parser = new DOMParser();
            const html = parser.parseFromString(isweb[1].content, 'text/html');
            this.htmlContent = html.documentElement.textContent

            //Serve???????
            //this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(html.documentElement.textContent);
        }

      })

	}



    ngAfterViewInit(): void {




    }

}
